export const insuranceExplanation = (insurance: string, company: string) => (
  <p className="explanation">
    <strong>Why {company}: </strong> Look, for the most part, {insurance} is
    equivalent between providers. Thus, you simply need a tool that let{`'`}s
    you compare quotes between providers with minimal hassle, apply online, and
    get help from licensed agent. {company} is that tool, at least for{' '}
    {insurance}! It{`'`}s also free and will not sell your information.
  </p>
)

export const loanExplanation = (loan: string, company: string) => (
  <p className="explanation">
    <strong>Why {company}: </strong> Look, for the most part,
    {'student loans' === loan ? ' private ' : ' '}
    {loan} are the same between lenders. Thus, you simply need a tool that let
    {`'`}s you compare quote between lenders with minimal hassle, apply online,
    and get help. {company} is that tool, at least for {loan}! It is also free
    and will not sell your information. Beyond that, you should also check with
    your local credit unions and the big banks in your area. That is because no
    online tool, no matter how good, will cover every option.{' '}
    {'home loans' === loan &&
      'For even more options, you can also use a local mortgage broker. For the largest transaction of your life, it never hurts to be too careful!'}
  </p>
)

export const creditCardsExplanation = (card_type: string) => (
  <p>
    <strong>Why: </strong> So here is the thing about credit cards. One, there
    is not a ton of difference between each one of the same type. For example,
    between two {card_type}. Two, the offers change all the time. And three,
    many websites on the Internet have written about the "best" credit card.
    They have done the hard work for you! Hence, to find the best credit card
    for your situation, including <strong>{card_type}</strong>, we recommend
    Google or Bing. Seriously! Ten minutes with a "Best {card_type}" search will
    give you an updated list.
  </p>
)
